export const INVITED = 'Invited';
export const DECLINED = 'Declined';
export const PENDING = 'Pending';
export const ACTIVE = 'Active';
export const DEACTIVATED = 'Deactivated';
export const FLAGGED = 'Flagged';
